/**
 * PAPPO — Users Service
 * Perfil do próprio utilizador (GET /api/users/me).
 */

import { apiGet } from './api';
import type { User } from '../types/user';

/** Perfil atual: id, nível, flags de verificação (mata a sessão stale). */
export async function getMe() {
  return apiGet<User>('/users/me');
}
